// extracted by mini-css-extract-plugin
export var phone = "_17-0";